export const typographyStyles = {
  monospace: {
    fontFamily: '"Courier New", monospace',
  },
};